<script setup lang="ts">
  import { FlowCard } from '@/shared/components/rebranding/FlowCard'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import RelationshipField from './fields/RelationshipField.vue'
  import NationalityField from './fields/NationalityField.vue'
  import { useI18n } from 'vue-i18n'
  import type { Validation } from '@vuelidate/core'
  import type { CountryWithDetailsType } from '@/shared/types/other.types'

  interface Props {
    localNationalities: CountryWithDetailsType[]
    relations: Array<{ code: string; desc: string }>
    errors: { nationality?: string[]; relationship?: string[] }
    v$: Validation
    disabledNationality: boolean
    findNationality: (s: string) => CountryWithDetailsType[]
    isLoading: boolean
    ocrIsAvailable: boolean
  }

  const { locale } = useI18n()

  const relationship = defineModel<string | null>('relationship', { required: true })
  const selectedNationality = defineModel<CountryWithDetailsType | undefined>('selectedNationality')

  defineProps<Props>()
</script>

<template>
  <FlowCard
    class="visitor-form"
    :class="{ 'visitor-form--loading': isLoading }"
    :title="$t('visitors.fill_visitors_info.personal_info.additional.header')"
    :with-button="false"
    padding="var(--spacing-8)"
  >
    <template #subtitle>
      <!-- @vue-ignore -->
      <p
        class="visitor-form__annotation"
        :class="{ 'text-medium': !$qicConnect.isMobile, 'text-regular': $qicConnect.isMobile }"
      >
        {{ $t('qic_personal_info_annotation') }}
      </p>
    </template>
    <WrapperQC direction="column" gap="var(--spacing-5)">
      <RelationshipField
        v-model="relationship"
        :relations="relations"
        :errors="errors.relationship"
        :is-valid="!v$.relationship.$dirty && !v$.relationship.$invalid"
        :locale="locale"
      />
      <NationalityField
        v-model="selectedNationality"
        :countries="localNationalities"
        :errors="errors.nationality"
        :is-valid="!v$.nationality.$dirty && !v$.nationality.$invalid"
        :disabled="disabledNationality"
        :filter-function="findNationality"
        :locale="locale"
        :label="
          ocrIsAvailable
            ? $t('visitors.travel_dates_page.nationality')
            : $t('qlm_nationality')
        "
      />
    </WrapperQC>
  </FlowCard>
</template>

<style lang="scss" scoped>
  .visitor-form {
    position: relative;
  }
  .visitor-form__annotation {
    text-align: center;
    @media (max-width: 550px) {
      font-size: 14px;
    }
  }
</style>
